import React from 'react';
import {
  Card,
  CardHeader,
  CardText,
  FontIcon,
  IconButton,
} from 'material-ui';
import R from 'ramda';
import PropTypes from 'prop-types';
import ErrorCheckIcon from '../../draftNTemplate-container/error-check-indicator-icon';
import LeftNavWidget from '../../../generic-components/left-nav-widget';
import { SmallFlatButton } from '../../../../tc-ui/small-buttons';

const simpleStyle = { marginLeft: '18px', padding: '0 4px 0 0' };
class RatePackageGroup extends React.Component {
  constructor(props) {
    super(props);
    const {
      productId,
      thisProductId,
    } = props;
    this.state = {
      isExpanded: productId === thisProductId,
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      productId,
      thisProductId,
    } = this.props;
    // route change
    if (
      nextProps.thisProductId !== thisProductId
      && nextProps.thisProductId === productId
    ) {
      this.state = {
        isExpanded: true,
      };
    }
  }


  render() {
    const {
      urlPartial,
      location,
      productName,
      managePackages,
      supplierEditable,
      showErrorForProduct,
      turnOnSort,
      changeLeftNavRoute,
      ratePackages,
      productsErrors,
    } = this.props;

    const {
      isExpanded,
    } = this.state;

    const labelForProductName = !supplierEditable ? (
      <div style={{ whiteSpace: 'pre-wrap', width: 'calc(100% - 40px)' }}>
        {productName}
      </div>
    ) : (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'pre-wrap',
          width: 'calc(100% - 40px)',
        }}
      >
        {supplierEditable && (
          <ErrorCheckIcon showError={showErrorForProduct} />
        )}
        {productName}
      </div>
    );
    return (
      <Card
        expandable
        expanded={isExpanded}
        onExpandChange={expanded => this.setState({ isExpanded: expanded })}
        style={{ backgroundColor: '#f5f6fb', boxShadow: 'none' }}
      >
        <CardHeader
          style={{ ...simpleStyle, padding: '12px 4px 12px 0' }}
          textStyle={{ display: 'none' }}
          actAsExpander
          showExpandableButton
        >
          {labelForProductName}
        </CardHeader>
        <CardText expandable style={{ padding: 0 }}>
          {
            // render rate packages
            ratePackages.map(ratePackage => {
              const ratePackageName = ratePackage.ratePackageName || 'Primary';
              const errorsObj = R.find(productInError => productInError.ratePackageIndex
                === ratePackage.ratePackageIndex, productsErrors);
              const percent = errorsObj ? errorsObj.percent : 100;
              const label = !supplierEditable ? (
                <div style={{ paddingLeft: '32px' }}>
                  {ratePackage.ratePackageName || 'Primary'}
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '32px' }}>
                  {supplierEditable && (
                    <ErrorCheckIcon showError={percent !== 100} />
                  )}
                  {ratePackageName}
                </div>
              );
              const ratePackageId = (() => {
                if (ratePackage._id) return ratePackage._id;
                return encodeURIComponent(ratePackageName);
              })();
              return (
                <LeftNavWidget
                  key={ratePackageName}
                  routeName={`${urlPartial}/${ratePackageId}`}
                  name={label}
                  location={location}
                  onTouchTap={() => changeLeftNavRoute(`${urlPartial}/${ratePackageId}`)}
                />
              );
            })
          }
          {
            // Boolean(supplierEditable) && (
            //   <div className="flex-tc-sb">
            //     <SmallFlatButton
            //       label="Sort"
            //       onTouchTap={turnOnSort}
            //       style={{ border: '1px solid rgba(0, 0, 0, 0.64)', marginLeft: '48px' }}
            //       labelStyle={{ padding: '4px 8px 4px 2px', color: 'rgba(0, 0, 0, 0.64)' }}
            //       icon={(
            //         <FontIcon
            //           className="tc-icon-swap_vert"
            //           style={{ color: 'rgba(0, 0, 0, 0.64)' }}
            //         />
            //       )}
            //     />
            //     <SmallFlatButton
            //       label="Manage Rate Packages"
            //       onTouchTap={managePackages}
            //       secondary
            //       style={{ border: '1px solid #00bcd4', marginRight: '16px' }}
            //       labelStyle={{ padding: '4px 8px' }}
            //     />
            //   </div>
            // )
          }
        </CardText>
      </Card>
    );
  }
}

RatePackageGroup.defaultProps = {
  showErrorForProduct: false,
  productsErrors: [],
  managePackages: () => {},
  turnOnSort: () => {},
  thisProductId: '',
  urlPartial: '',
  productId: '',
};

RatePackageGroup.propTypes = {
  location: PropTypes.object.isRequired,
  productId: PropTypes.string,
  productName: PropTypes.string.isRequired,
  supplierEditable: PropTypes.bool.isRequired,
  showErrorForProduct: PropTypes.bool,
  turnOnSort: PropTypes.func,
  changeLeftNavRoute: PropTypes.func.isRequired,
  ratePackages: PropTypes.array.isRequired,
  productsErrors: PropTypes.array,
  managePackages: PropTypes.func,
  urlPartial: PropTypes.string,
};

export default RatePackageGroup;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/products/rate-package-group.jsx